import { mdiHospitalBuilding } from '@mdi/js';
import React from 'react';
import { ActionMenuBadge, IActionMenuBadgeItem } from './action-menu-badge';
import { BadgeIcon } from './badge-icon';
import { generateLabel } from './util';

export interface IFacilityBadgeProps {
    className?: string;
    id?: string;
    name?: string;
    tooltip?: string;
    items?: IActionMenuBadgeItem[];
}
export const FacilityBadge: React.FunctionComponent<IFacilityBadgeProps> = (
    props: IFacilityBadgeProps,
): React.ReactElement => {
    const { className, id, name, tooltip, items } = props;
    return (
        <ActionMenuBadge
            className={className}
            label={generateLabel('Facility', id, name)}
            tooltip={tooltip}
            items={items}
            id={id}
            Symbol={<BadgeIcon path={mdiHospitalBuilding} />}
        />
    );
};
